import { TCertificationSchema } from 'transfix-form/forms/CarrierCertifications/components/CertificationModal/schema/CertificationSchema'
import { IUpdateCarrierCertificationInput, Maybe } from 'types/graphqlTypes'

export const getUpdateCarrierCertificationInput = ({
  carrierApplicationId,
  formValues,
}: {
  formValues: TCertificationSchema
  carrierApplicationId: string
}): Maybe<IUpdateCarrierCertificationInput> => {
  const { code } = formValues || {}

  if (!code) {
    return null
  }

  return {
    ...formValues,
    carrierApplicationId,
    code,
  }
}
